module.exports = __webpack_public_path__ + "01c4c12f94167a567a69a95606ae752a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-1.png
// module id = 2025
// module chunks = 0